const parseTimestamp = (date) => new Date(date.replace("Z", ""));

export default parseTimestamp;
